/** Theme palettes ported verbatim from reference/SpeedReaderv2.html (visual
 * reference: port the design language, do NOT redesign). Applied as CSS
 * custom properties on <html>. Dark-first. */

export type ThemeName = 'dark' | 'light' | 'amoled';

export interface Theme {
  readonly bg: string;
  readonly surface: string;
  readonly surfaceAlt: string;
  readonly border: string;
  readonly borderHover: string;
  readonly text: string;
  readonly textMuted: string;
  readonly textDim: string;
  readonly accent: string;
  readonly accentGlow: string;
  readonly accentSoft: string;
  readonly progress: string;
  readonly progressBg: string;
  readonly buttonBg: string;
  readonly buttonHover: string;
}

export const THEMES: Readonly<Record<ThemeName, Theme>> = {
  dark: {
    bg: '#07070d',
    surface: '#0f1018',
    surfaceAlt: '#161822',
    border: '#1e2030',
    borderHover: '#2a2e45',
    text: '#d4d2cc',
    textMuted: '#6b6f82',
    textDim: '#3d4058',
    accent: '#E74C3C',
    accentGlow: 'rgba(231,76,60,0.25)',
    accentSoft: 'rgba(231,76,60,0.08)',
    progress: '#E74C3C',
    progressBg: '#1a1c2a',
    buttonBg: '#161822',
    buttonHover: '#1e2030',
  },
  light: {
    bg: '#f5f3ee',
    surface: '#ffffff',
    surfaceAlt: '#faf9f6',
    border: '#e0ddd5',
    borderHover: '#c8c4b9',
    text: '#1a1a1a',
    textMuted: '#6b6860',
    textDim: '#b0ada5',
    accent: '#c0392b',
    accentGlow: 'rgba(192,57,43,0.2)',
    accentSoft: 'rgba(192,57,43,0.06)',
    progress: '#c0392b',
    progressBg: '#e8e5dd',
    buttonBg: '#f0ede6',
    buttonHover: '#e5e2d9',
  },
  amoled: {
    bg: '#000000',
    surface: '#080808',
    surfaceAlt: '#101010',
    border: '#1a1a1a',
    borderHover: '#282828',
    text: '#e0e0e0',
    textMuted: '#606060',
    textDim: '#303030',
    accent: '#E74C3C',
    accentGlow: 'rgba(231,76,60,0.3)',
    accentSoft: 'rgba(231,76,60,0.08)',
    progress: '#E74C3C',
    progressBg: '#1a1a1a',
    buttonBg: '#0a0a0a',
    buttonHover: '#1a1a1a',
  },
};

export function applyTheme(name: ThemeName): void {
  const theme = THEMES[name];
  const root = document.documentElement;
  for (const [key, value] of Object.entries(theme)) {
    root.style.setProperty(`--${key}`, value);
  }
  root.dataset['theme'] = name;
  const meta = document.querySelector('meta[name="theme-color"]');
  meta?.setAttribute('content', theme.bg);
}
